import { useState } from 'react'
import { Alert, Segmented, Skeleton, StatusHint } from '@indipia/ui-core'
import type { PreviewState, GeneralPreviewTarget } from '../hooks/useScheduleSharePreview'
import type { SharePreviewGroup } from '../api/scheduleShareApi'
import { KakaoMessageCard } from './KakaoTemplatePreview'

// 스케줄 공유 알림톡 미리보기 — 서버(Hermes 렌더)가 준 문구·버튼을 그대로 보여준다.
// 프론트에서 문구를 조립하지 않는다(확정 결정 36·40). 수신자 유형 전환은 Segmented, 호출 지연은 Skeleton, 오류는 Alert.

const GROUP_OPTIONS = [
  { label: '고객', value: 'CUSTOMER' },
  { label: '반장·거래처', value: 'GENERAL' },
]

interface Props {
  customer: PreviewState
  general: PreviewState
  generalTarget: GeneralPreviewTarget | null
}

export function ScheduleSharePreviewPanel({ customer, general, generalTarget }: Props) {
  const [group, setGroup] = useState<SharePreviewGroup>('CUSTOMER')
  const state = group === 'CUSTOMER' ? customer : general

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Segmented
        size="sm"
        options={GROUP_OPTIONS}
        value={group}
        onChange={v => setGroup(v as SharePreviewGroup)}
      />

      {group === 'GENERAL' && !generalTarget && (
        <StatusHint tone="muted">반장·거래처를 추가하면 미리보기가 표시됩니다.</StatusHint>
      )}
      {group === 'GENERAL' && generalTarget && (
        <StatusHint tone="muted">{generalTarget.recipient.name} · {generalTarget.workTypeName} 기준</StatusHint>
      )}

      {state.status === 'loading' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Skeleton height={44} />
          <Skeleton height={140} />
          <Skeleton height={36} />
        </div>
      )}

      {state.status === 'error' && <Alert kind="error">{state.error}</Alert>}

      {state.status === 'ready' && state.data && (
        <KakaoMessageCard
          content={state.data.body}
          buttons={state.data.buttons.map(b => b.name)}
        />
      )}
    </div>
  )
}
